var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _toConsumableArray = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _asyncToGenerator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var WTError = require('../../error');

var logger = require('../../config/logger');

var futureFile = require('../models/future-file');

var RemoteFile = require('../models/remote-file');

var contentForFiles = require('../../utils/content-for-files');

module.exports = function (_ref) {
  var request = _ref.request,
      routes = _ref.routes,
      uploadFileToBoard = _ref.uploadFileToBoard;

  /**
   * Check if the user also passed the content for files.
   * In that case, we can upload the files in one go.
   *
   * @param {Array} files A list of file object, containing name, size and maybe content
   */
  function shouldUploadFiles(files) {
    return files.reduce(function (uploadFiles, file) {
      return uploadFiles && Boolean(file.content);
    }, true);
  }
  /**
   * Add files to an existing board.
   * @param   {Object}  board Existing board object
   * @param   {Array}   files A board of files to be added to the board
   * @returns {Promise}       A board of created items
   */


  return (
    /*#__PURE__*/
    function () {
      var _addFilesToBoard = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(board, files) {
        var response, boardFiles, filesContent;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                logger.info("Adding ".concat(files.length, " files to board with ID ").concat(board.id));
                _context.next = 4;
                return request.send(routes.boards.addFiles(board), files.map(futureFile));

              case 4:
                response = _context.sent;
                boardFiles = response.map(function (item) {
                  return new RemoteFile(item);
                });
                board.addFiles.apply(board, _toConsumableArray(boardFiles));

                if (!shouldUploadFiles(files)) {
                  _context.next = 11;
                  break;
                }

                filesContent = contentForFiles(files);
                _context.next = 11;
                return Promise.all(boardFiles.map(function (file) {
                  return uploadFileToBoard(board, file, filesContent[file.name]);
                }));

              case 11:
                return _context.abrupt("return", boardFiles);

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](0);
                throw new WTError('There was an error when adding files to the board.', _context.t0);

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 14]]);
      }));

      function addFilesToBoard(_x, _x2) {
        return _addFilesToBoard.apply(this, arguments);
      }

      return addFilesToBoard;
    }()
  );
};